module.exports = __webpack_public_path__ + "static/webinar-bg.bd76c97b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/webinar-bg.jpg
// module id = 1307
// module chunks = 35783957827783